var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSyncIco({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 15,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5069 9.98145L18.6378 8.06106L19.6705 7L22.7861 10.2012C23.0713 10.4942 23.0713 10.9693 22.7861 11.2623L19.6705 14.4635L18.6378 13.4024L20.5069 11.482H10.8458C9.52842 11.482 8.46045 12.5793 8.46045 13.9329V15.5335H7V13.9329C7 11.7506 8.72184 9.98145 10.8458 9.98145H20.5069ZM23 14.4665V16.0671C23 18.2494 21.2782 20.0186 19.1542 20.0186H9.49314L11.3622 21.9389L10.3295 23L7.21388 19.7988C6.92871 19.5058 6.92871 19.0307 7.21388 18.7377L10.3295 15.5365L11.3622 16.5976L9.49314 18.518H19.1542C20.4716 18.518 21.5396 17.4207 21.5396 16.0671V14.4665H23Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyncIco);
export default __webpack_public_path__ + "static/media/sync_ico.e66bce23da7f96bdf90820978e1abe97.svg";
export { ForwardRef as ReactComponent };